package com.mps.asc_app.util

import kotlin.js.Date

actual fun startOfDayEpochMillis(year: Int, month: Int, day: Int): Long {
    return Date(year, month - 1, day, 0, 0, 0, 0).getTime().toLong()
}

actual fun endOfDayEpochMillis(year: Int, month: Int, day: Int): Long {
    return Date(year, month - 1, day + 1, 0, 0, 0, 0).getTime().toLong()
}

actual fun epochMillisToLocalTimeLabel(epochMillis: Long): String {
    val date = Date(epochMillis.toDouble())
    val hours = date.getHours().toString().padStart(2, '0')
    val minutes = date.getMinutes().toString().padStart(2, '0')
    return "$hours:$minutes"
}
